import PageLayout from '@/components/decorators/PageLayout';
import TCDecorator from '@/components/tc/decorator/TCDecorator';
import getConfig from 'next/config';
import {Helmet} from 'react-helmet';
import Link from 'next/link';

const nextConfig = getConfig();

const About = (props: {healthCheckEnabled: string}) => {
  if (props.healthCheckEnabled === 'true') {
    return (
      <TCDecorator>
        <Helmet>
          <title>About | TurboCurator by ICPSR</title>
        </Helmet>
        <h1 data-testid="header1" className="my-4">
          About
        </h1>
        <p data-testid="paragraph1">
          TurboCurator by ICPSR assists data depositors by providing
          recommendations for enhancing metadata quality before publication.
        </p>
        <p>
          Data depositors are encouraged to complete as many metadata fields as
          possible. While TurboCurator is intended to improve metadata prior to
          publication, the tool can also be used for published datasets or
          studies.
        </p>
        <p>
          Currently, TurboCurator should only be used for non-sensitive data.
        </p>
        <h3 data-testid="howItWorksHeader">How it works</h3>
        <p>
          Prior to publication, TurboCurator uses the following to improve the
          quality of metadata:
        </p>
        <ol>
          <li>
            Metadata entries, e.g., title, description/summary, and
            keywords/ICPSR subject terms.
          </li>
          <li>Additional text entered in TurboCurator from research sources</li>
        </ol>
        <p>
          TurboCurator generates recommendations powered by OpenAI’s ChatGPT
          technology and ICPSR’s suggestion logic. Suggestions are provided for
          Title, Description, and Keywords.
        </p>
        <ul>
          <li>
            Title and Description/Summary fields are automatically suggested
            based on ICPSR’s 60 years of experience curating and preserving
            data. Keywords/ICPSR Subject Terms will follow{' '}
            <Link
              href="https://www.icpsr.umich.edu/web/ICPSR/thesaurus/10001"
              target="_blank"
              rel="noopenner referrer"
              data-testid="thesaurusLink"
            >
              ICPSR social science thesaurus preferred terms (new tab).
            </Link>
          </li>
        </ul>

        <p>
          Data depositors may accept, ignore or modify suggestions. Dataverse
          users will need to manually copy metadata recommendations back to
          their deposit. Metadata improvements will make it easier for others to
          find and reuse their data.
        </p>

        <p>
          See our{' '}
          <Link href="FAQ" data-testid="faqLink">
            Frequently Asked Questions
          </Link>{' '}
          for more information on TurboCurator by ICPSR.
        </p>
      </TCDecorator>
    );
  } else {
    return (
      <PageLayout>
        <Helmet>
          <title>TurboCurator currently not available</title>
        </Helmet>
        <div className="m-3">
          Page is not available for use yet. Please contact CNS administrator
          for assistance
        </div>
      </PageLayout>
    );
  }
};

export async function getServerSideProps() {
  return {
    props: {
      healthCheckEnabled: nextConfig.publicRuntimeConfig.healthCheckEnabled,
    },
  };
}

export default About;
